<ion-header class="remove-margin-from-safe-area ion-no-border">
  <ion-toolbar >
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-toolbar>
          <ion-buttons slot="end">
            <ion-button (click)="closeModal()" 
              ><ion-icon color="dark" name="close"></ion-icon
            ></ion-button>
          </ion-buttons>
        </ion-toolbar>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col style="text-align: center;">
          <h2 class="subheader-regular">{{ ('keys.data.payments.confirm_payment' |
    translate  : {Default:'Confirm Payment'}) || 'Confirm Payment' }}</h2>
        </ion-col>
      </ion-row>
    </ion-grid>
    
   
  </ion-toolbar>
</ion-header>

<ion-content>
  <app-pagecontent  [path]="'guest/confirm'"></app-pagecontent>
  <ion-grid *ngIf="detectTouch && submitLoading"  style="height: 100%;">
    <ion-row (click)="closeModal()" style="  
    align-items: center;
   
    height: 100%;">
  
  </ion-row>
    </ion-grid>
    <ion-grid class="single-col-wider">
      <ion-row>
        <ion-col class="ion-no-padding"  size="12">
          <ion-item lines="none" class="paragraph-input-fields-regular">
          <ion-label 
            >{{ ('keys.data.common.subtotal' |
            translate : {Default:'Subtotal'}) || 'Subtotal' }}
           
          </ion-label>
          <ion-label class="ion-text-wrap ion-text-right">
            {{cartTotal['sub_total'] | currency}}
          </ion-label>
        </ion-item>
        </ion-col>
      
      
      </ion-row>
      <ion-row *ngFor="let fee of fees">
      <ion-col class="ion-no-padding"  *ngIf="fee['amount']!=null" size="12">
      <ion-item lines="none" class="paragraph-input-fields-regular">
        <ion-label 
          >{{ fee['label']}}
          
        </ion-label>
        <ion-label class="ion-text-wrap ion-text-right">
          {{fee['amount']| currency}}
        </ion-label>
      </ion-item>
      </ion-col>
      </ion-row>
      <ion-row *ngFor="let tax of cartTotal?.taxes">
      <ion-col class="ion-no-padding">
      <ion-item lines="none" class="paragraph-input-fields-regular">
        <ion-label 
          >{{ ('keys.data.common.taxes' |
          translate : {Default:'Taxes'}) || 'Taxes' }}
         
        </ion-label>
        <ion-label class="ion-text-wrap ion-text-right">
          {{tax| currency}}
        </ion-label>
      </ion-item>
      </ion-col>
      </ion-row>
      <ion-row >
        <ion-col class="ion-no-padding">
        <ion-item lines="none" class="paragraph-input-fields-bold">
          <ion-label 
            >{{ ('keys.data.common.total' |
            translate : {Default:'Total'}) || 'Total' }}
            
          </ion-label>
          <ion-label class="ion-text-wrap ion-text-right">
            {{cartTotal['total']| currency}}
          </ion-label>
        </ion-item>
        </ion-col>
        </ion-row>
        <ion-row>
          <ion-col style="text-align: center;">
            <ion-label class="paragraph-bold"> {{ ('keys.data.payments.payment_method' |
             translate : {Default:'Payment Method'}) || 'Payment Method' }}</ion-label>
           </ion-col>
        </ion-row>
        <ion-row *ngIf="payType?.['promptFor']==null && cartTotal['total']==0">
          <ion-grid>
            <ion-row >
              <ion-col style="text-align: center;">
                <ion-card class="card-shadow-3">
                  <ion-item>
                <ion-label style="font-weight: bold">
                  {{ ('keys.data.common.zero_dollar_item' |
                  translate : {Default:'Zero Dollar Item'}) || 'Zero Dollar Item' }}
                </ion-label>
              </ion-item>
              </ion-card>
              </ion-col>
             </ion-row>
          </ion-grid>
        </ion-row>
        <ion-row *ngIf="cartTotal['total']>0">
          <ion-col>
            <ion-card>
            <ion-item lines="none">
            <ion-label class="paragraph-input-fields-bold">
              {{payType['PaymentTypeName']}}
            </ion-label>
          </ion-item>
        </ion-card>
          </ion-col>
        </ion-row>
      <form [formGroup]="paymentForm"> 
        <ion-grid>
          <ion-row *ngIf="payType?.['promptFor']!=null">
            <ion-col style="text-align: center;">
              <h2 class="subheader-regular">
                {{ ('keys.data.reports.user_details' |
              translate  : {Default:'User Details'}) || 'User Details' }}
              </h2>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="payType['promptFor'].toLowerCase()=='anonymous'">
            <ion-col>
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label style="font-weight: bold">Email:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$"
                  [formControlName]="'email'"
                  required
                  type="email"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="payType['promptFor'].toLowerCase()=='billing'">
            <ion-col size="12">
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label  style="font-weight: bold">{{ ('keys.data.users_login.email' |
                  translate  : {Default:'Email'}) || 'Email' }}:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{1,4}$"
                  [formControlName]="'email'"
                  required
                  type="email"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.name' |
                  translate  : {Default:'Full Name'}) || 'Full Name' }}:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  [formControlName]="'name'"
                  required
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.phone_number' |
                  translate : {Default:'Phone Number'}) || 'Phone Number' }}:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  [formControlName]="'phone_number'"
                  required
                  type="phone"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.address1' |
                  translate : {Default:'Address Line 1'}) || 'Address Line 1' }}:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  [formControlName]="'address_1'"
                  required
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.address2' |
                  translate : {Default:'Address Line 2'}) || 'Address Line 2' }}:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  [formControlName]="'address_2'"
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.profile.city' |
                  translate : {Default:'City'}) || 'City' }}:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  
                  [formControlName]="'city'"
                  
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.common.province_or_state' |
                  translate : {Default:'Province or State'}) || 'Province or State' }}:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  
                  [formControlName]="'province'"
                  
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
            <ion-col size="12">
              <ion-card class="card-shadow-3">
              <ion-item>
                <ion-label style="font-weight: bold">{{ ('keys.data.common.postalcode_or_zipcode' |
                  translate : {Default:'Postal Code/Zip Code'}) || 'Postal Code/Zip Code' }}:</ion-label>
                <ion-input [disabled]="paymentSubmitted"
                  
                  [formControlName]="'postal'"
                  required
                  type="text"
                ></ion-input>
              </ion-item>
            </ion-card>
            </ion-col>
          </ion-row>
          
          <ion-row>
            <ion-col *ngIf="!paymentSubmitted" size="10" offset="1">
              <ion-button (click)="submitPayment()" [disabled]="processLoading ||!paymentForm.valid" expand="block" color="primary">{{ ('keys.data.data.common.next' |
                translate : {Default:'Next'}) || 'Next' }}<ion-spinner *ngIf="processLoading"></ion-spinner> </ion-button>
              
            </ion-col>
            <ion-col *ngIf="paymentSubmitted" size="10" offset="1">
              <ion-button [disabled]="submitLoading ||!paymentForm.valid" (click)="processPayment()"  expand="block" color="primary">{{ ('keys.data.payments.confirm_payment' |
                translate : {Default:'Confirm Payment'}) || 'Confirm Payment' }}<ion-spinner *ngIf="submitLoading"></ion-spinner> </ion-button>
              
            </ion-col>
          </ion-row>
          </ion-grid>
        </form
    >
    </ion-grid>
  
</ion-content>
